<template>
  <div class="editorial-collage-wrapper">
    <!-- MENSAJE DE LA NIÑA INTERIOR -->
    <div class="inner-child-message">
      <p class="poema-linea">
      </p>
    </div>

    <div class="collage-container">
      <!-- 🎀 SELLO DE LACRE DECORATIVO -->
      <img 
        src="@/assets/lacre.png" 
        alt="Sello de lacre" 
        class="wax-seal" 
      />

      <!-- MESA ASIMÉTRICA EDITORIAL (15 FOTOS) -->
      <div class="asymmetric-grid">
        <div
          v-for="(item, index) in items"
          :key="index"
          ref="photoItems"
          class="photo-card"
          :class="['layout-type-' + (index % 6), { 'card-wide': index === 2 || index === 7 }]"
          @click="handleItemClick(index)"
        >
          <div class="photo-inner">
            <img
              :src="item"
              class="photo-img"
              :alt="'Foto ' + (index + 1)"
              loading="lazy"
            >
            <div class="photo-overlay">
              <span class="expand-icon">✦</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal (Para ver fotos en pantalla completa) -->
    <Transition name="fade">
      <div
        v-if="isImageEnlarged"
        class="image-modal"
        @click="closeModal"
      >
        <button class="close-btn" @click="closeModal">&times;</button>
        <img
          :src="items[currentIndex]"
          class="enlarged-image"
        >
      </div>
    </Transition>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAsimetricoModerno',
  setup() {
    // Tus 15 fotos
    const items = [
            require('@/assets/image23.jpeg'),

      require('@/assets/111.png'),
      require('@/assets/222.png'),
      require('@/assets/333.png'),
      require('@/assets/444.png'),
      require('@/assets/555.png'),
      require('@/assets/666.png'),
      require('@/assets/777.png'),
      require('@/assets/image2.png'),
      require('@/assets/999.png'),
      require('@/assets/101010.png'),
      require('@/assets/111111.png'),
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    const photoItems = ref([])

    const handleItemClick = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    // ANIMACIÓN MODERNA CON DESENFOQUE Y ROTACIÓN SUTIL
    const observeAndAnimate = () => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = photoItems.value.indexOf(entry.target)
            const randomRotation = (index % 2 === 0 ? 1 : -1) * (2 + (index % 3))

            gsap.fromTo(
              entry.target,
              {
                opacity: 0,
                y: 80,
                scale: 0.9,
                rotation: randomRotation * 1.5,
                filter: 'blur(8px)'
              },
              {
                opacity: 1,
                y: 0,
                scale: 1,
                rotation: randomRotation,
                filter: 'blur(0px)',
                duration: 1.2,
                delay: (index % 3) * 0.15,
                ease: 'power3.out'
              }
            )
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.12 })

      photoItems.value.forEach((el) => {
        if (el) observer.observe(el)
      })
    }

    onMounted(async () => {
      await nextTick()
      photoItems.value = photoItems.value.slice(0, items.length)
      observeAndAnimate()

      // Animación del sello de lacre
      gsap.fromTo(
        '.wax-seal',
        { scale: 0, opacity: 0, rotation: -90 },
        { scale: 1, opacity: 1, rotation: 0, duration: 1.2, delay: 0.2, ease: 'back.out(2)' }
      )

      // Animación del texto
      gsap.fromTo(
        '.inner-child-message',
        { opacity: 0, y: -20 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }
      )
    })

    return {
      items,
      currentIndex,
      isImageEnlarged,
      handleItemClick,
      closeModal,
      photoItems
    }
  }
}
</script>

<style scoped>
.editorial-collage-wrapper {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 50px 18px;
  margin-top:-60px;
  box-sizing: border-box;
}

/* 🧸 MENSAJE POÉTICO */
.inner-child-message {
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
}

.inner-child-message .poema-linea {
  font-size: 1.15rem;
  line-height: 1.6;
  color: #B28F60;
  font-style: italic;
  max-width: 650px;
  margin: 0 auto;
  font-family: 'Playfair Display', serif;
}

.collage-container {
  position: relative;
  width: 100%;
}

/* 🎀 SELLO LACRE DECORATIVO */
.wax-seal {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  width: 85px;
  height: auto;
  z-index: 10;
  pointer-events: none;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.18));
}

/* MESA ASIMÉTRICA DINÁMICA */
.asymmetric-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding-top: 25px;
}

/* CARD ORGANICA Y MODERNA */
.photo-card {
  position: relative;
  cursor: pointer;
  will-change: transform, opacity;
  transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.4s ease, z-index 0.2s;
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
  padding: 6px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.07);
}

/* TAMAÑOS ALTERNADOS PARA DAR RITMO (NADA ABURRIDO NI CUADRADO) */
.layout-type-0 { width: calc(45% - 10px); height: 260px; }
.layout-type-1 { width: calc(50% - 10px); height: 310px; margin-top: 20px; }
.layout-type-2 { width: 95%; height: 240px; } /* Foto panorámica destacada */
.layout-type-3 { width: calc(30% - 10px); height: 220px; }
.layout-type-4 { width: calc(33% - 10px); height: 260px; margin-top: -15px; }
.layout-type-5 { width: calc(30% - 10px); height: 210px; }

.photo-inner {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
}

.photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  display: block;
  transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
}

.photo-overlay {
  position: absolute;
  inset: 0;
  background: rgba(178, 143, 96, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.expand-icon {
  color: #ffffff;
  font-size: 1.8rem;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
}

/* HOVER / TOUCH FLOTANTE SÚPER ELEGANTE */
.photo-card:hover {
  z-index: 20 !important;
  transform: scale(1.05) translateY(-8px) rotate(0deg) !important;
  box-shadow: 0 20px 38px rgba(0, 0, 0, 0.18);
}

.photo-card:hover .photo-img {
  transform: scale(1.08);
}

.photo-card:hover .photo-overlay {
  opacity: 1;
}

/* ADAPTACIÓN MÓVIL (Mantiene la asimetría hermosa en pantallas pequeñas) */
@media (max-width: 650px) {
  .asymmetric-grid {
    gap: 12px;
  }

  .layout-type-0 { width: 46%; height: 210px; }
  .layout-type-1 { width: 48%; height: 250px; margin-top: 15px; }
  .layout-type-2 { width: 96%; height: 200px; }
  .layout-type-3 { width: 46%; height: 200px; }
  .layout-type-4 { width: 48%; height: 230px; margin-top: 0; }
  .layout-type-5 { width: 96%; height: 210px; }

  .inner-child-message .poema-linea {
    font-size: 0.98rem;
  }

  .wax-seal {
    width: 65px;
    top: -25px;
  }
}

/* MODAL / AMPLIACIÓN DE FOTO */
.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(12, 12, 12, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 20px;
  backdrop-filter: blur(6px);
}

.enlarged-image {
  max-width: 92%;
  max-height: 85vh;
  border-radius: 16px;
  object-fit: contain;
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.6);
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 25px;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 2.5rem;
  cursor: pointer;
  line-height: 1;
}

/* Transición Fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>